/* eslint-disable react-refresh/only-export-components */ // FIXME
import { withJsonFormsControlProps } from "@jsonforms/react"
import { ControlProps, JsonFormsRendererRegistryEntry, or, rankWith, scopeEndsWith } from "@jsonforms/core"
import { NumericControl } from "@great-expectations/jsonforms-antd-renderers"

export const MinMaxNumericRegistryEntry: JsonFormsRendererRegistryEntry = {
  tester: rankWith(
    89, // this should always be lower than MinMaxRegistryEntry which should be tested first
    // this should only apply to min_max values where date and date-time are not options for the min_value or max_value type
    or(scopeEndsWith("#/properties/min_value"), scopeEndsWith("#/properties/max_value")),
  ),
  renderer: withJsonFormsControlProps(MinMaxNumericControl),
}

// This control is designed to be used with min_value and max_value kwargs that can be a number.
// The control will render a NumericControl.
function MinMaxNumericControl(props: ControlProps) {
  return <NumericControl {...props} />
}
